var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.$t('settings.contextTypeOfEntities.title')}},_vm._l((_vm.entitiesTypes),function(entityType){return _c('v-checkbox',{key:entityType.value,attrs:{"input-value":_vm.value,"label":entityType.label,"value":entityType.value,"color":"primary","hide-details":""},on:{"change":_vm.$listeners.input}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }